import { Grid, Button, Typography, DialogActions, DialogContent } from '@mui/material';
import { DialogCustom, DialogTitleCustom } from '@tap/mui-ui';
import { ICancelDialogResult, IDialogProps } from '@tap/tap-ui';
import { ApiUserFilter } from '@tap/data-providers';

/*
*   Диалог: Удалить фильтр
*/

type IDeleteFilterDialogProps = IDialogProps<{
    handleDeleteUserFilter: () => void,
    userFilter: ApiUserFilter,
}, ICancelDialogResult>;


export default function DeleteFilterDialog({
    data,
    isOpen,
    handleClose,
}: IDeleteFilterDialogProps) {

    const handleCancel = () => {
        handleClose({ isCancel: true });
    }

    const handleMainAction = () => {
        handleClose({ isCancel: true });
        data.handleDeleteUserFilter();
    }


    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
            dialogMaxWidth={'600px'}
        >
            <DialogTitleCustom
                primaryText={'Подтвердите удаление'}
            />
            <DialogContent>
                <Typography sx={{ marginBottom: '15px' }}>
                    Фильтр <strong>{`"${data.userFilter.name}"`}</strong> будет удалён без возможности восстановления.
                </Typography>

            </DialogContent>
            <DialogActions >
                <Grid container justifyContent='flex-end'>

                    <Button
                        disableElevation
                        type='button'
                        variant='contained'
                        color='primary'
                        onClick={handleMainAction}
                        sx={{ mr: 2 }}
                    >
                        Удалить
                    </Button>

                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>

                </Grid>
            </DialogActions>
        </DialogCustom >
    );
}
